import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { usePracticeViewerState, useDataEventsDispatch } from '../../../store/hooks/dataEvents';
import './styles.scss';

import Loader from '../../Shared/Loader';
import PVHeader from './Map/mapUtils/PVHeader';
import MapViewer from './MapViewer';
import PlayersTable from './Table/PlayersTable';

import { DEFAULT_FIELD, CONTROLLER_SET, PLAYERS_CATEGORIE } from '../../../config/constants';
import { cleanControllerSet } from '../../../helpers/helpers';
import { useTablePropertiesDispatch } from '../../../store/hooks/tableProperties';

import { Field } from './types';

const loaderProps = {
  style: {
    height: 'calc(100vh - 160px)',
    border: '2px solid rgba(219, 225, 229, 0.6)',
    zIndex: 400,
    opacity: 1
  }
};

const loadFieldData = (fields: Array<Field>) => {
  if (fields.length) {
    return { ...fields[0], isLoading: true, fieldIndex: 0 };
  } else {
    return { ...DEFAULT_FIELD, isLoading: true, fieldIndex: 0 };
  }
};

const PracticeViewer = ({shouldDisplayProgressBar, isNcaaGame}:{shouldDisplayProgressBar?:boolean, isNcaaGame?: boolean}) => {

  const { id: practiceId } = useParams<{ id: string }>();
  const { fields = [] } = usePracticeViewerState();
  const { cleanTracksDataOnUnmount } = useDataEventsDispatch();
  const { changePinnedRows } = useTablePropertiesDispatch();

  const [field, setField] = useState<Field>(loadFieldData(fields));
  const [onPlay, setOnPlay] = useState(false);
  const [wasOnPlay, setWasOnPlay] = useState(false);
  const [currentTab, setCurrentTab] = useState(PLAYERS_CATEGORIE);

  useEffect(() => {
    return () => {
      changePinnedRows([])();
      cleanTracksDataOnUnmount(practiceId);
      cleanControllerSet(CONTROLLER_SET);
    };
  }, []);

  return <div style={{width: '1280px'}}>
    <div className="practice-map">
      <div className="head-filters-01 practice-viewer-header">
        <PVHeader
          field={field}
          fields={fields}
          onPlay={onPlay}
          setField={setField}
          setOnPlay={setOnPlay}
          setWasOnPlay={setWasOnPlay}
        />
      </div>

      <Loader {...loaderProps} />

      <div className="practice-viewer-content">
        <div className="map-section">
          <MapViewer 
            field={field}
            fields={fields}
            onPlay={onPlay}
            setField={setField}
            setOnPlay={setOnPlay}
            wasOnPlay={wasOnPlay}
            mapImage={field.image}
            currentTab={currentTab}
            setWasOnPlay={setWasOnPlay}
            dimensions={field.dimensions}
          />
        </div>

        {<div className="players-section">
          <PlayersTable
            currentTab={currentTab}
            setCurrentTab={setCurrentTab}
            isProcessing={shouldDisplayProgressBar}
            isNcaaGame={isNcaaGame}
          />
        </div>}
      </div>
    </div>

  </div>;
};

export default PracticeViewer;